exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#page-not-found{text-align:center;font-weight:bold;font-size:60px}", ""]);

// exports
